import { API_BASE_URL } from "services/api/BaseUrl";

export const loginRegister = (params) =>
  fetch(
    `${API_BASE_URL}/auth/register`, 
    {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify(params),
    }
  )
  .then(res => res.json())

export const loginGoogleRegister = (params) =>
  fetch(
    `${API_BASE_URL}/auth/google-register`, 
    {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify(params),
    }
  )
  .then(res => res.json())
